import { NotificacoesResponse } from '../@types';
import aqilaApi from './aqila-api';

export type HistoricoItem = {
  id: number;
  tipo: string;
  tipoToPtBr: string;
  situacao: string;
  situacaoToPtBr: string;
  hint: string;
  lida: boolean;
  createdAt: string;
  tempoDecorrido: string;
  gleba: {
    id: number;
    descricao: string;
    cor: string;
    areaTotal: string;
    cdPropriedade: number;
  };
};

export type HistoricoPropriedade = {
  historicos: HistoricoItem[];
  propriedade: string;
};

class Notificacoes {
  private readonly endpoint = '/v1/notificacoes';

  async list(params?: Record<string, unknown>) {
    const { data } = await aqilaApi.get<NotificacoesResponse>(this.endpoint, {
      params,
    });
    return data;
  }

  async byPropriedade(propriedadeId: number): Promise<HistoricoItem[]> {
    const { data } = await aqilaApi.get<HistoricoPropriedade>(
      `v1/historicos/${propriedadeId}`,
    );
    return data.historicos;
  }
}

export default new Notificacoes();
